export const GENOMIC_LIFE_REFERRAL_INVITE_URL =
  "https://www.genomiclife.com/invite";

export const GENOMIC_LIFE_REFERRAL_INVITE_LINK_LABEL = "genomiclife.com/invite";

export const GENOMIC_LIFE_GIFTS_PAGE_URL = "https://www.genomiclife.com/gifts";

export const GENOMIC_LIFE_PUBLIC_INVITES_URL =
  "https://www.genomiclife.com/invites";

export const GENOMIC_LIFE_PUBLIC_INVITES_LINK_LABEL = "genomiclife.com/invites";

export const GENOMIC_LIFE_GIFTS_PAGE_LINK_LABEL = "genomiclife.com/gifts";

export const GENOMIC_LIFE_PUBLIC_MARKETING_HOME_URL =
  "https://www.genomiclife.com/";

export const GENOMIC_LIFE_PUBLIC_TERMS_OF_USE_URL =
  "https://www.genomiclife.com/terms-of-use";

export const GENOMIC_LIFE_PUBLIC_PRIVACY_POLICY_URL =
  "https://www.genomiclife.com/privacy-policy";

export const GENOMIC_LIFE_PUBLIC_POLICIES_URL =
  "https://genomiclife.com/about/policies/";

export const GENOMIC_LIFE_INVITE_DETAILS_URL =
  "https://www.genomiclife.com/for-individuals/invite-details";

export const GENOMIC_LIFE_INVITE_DETAILS_LINK_LABEL =
  "genomiclife.com/for-individuals/invite-details";

export const GENOMIC_LIFE_HOW_TO_INVITE_EMAIL_COMPOSER_URL =
  "https://www.genomiclife.com/for-individuals/how-to-invite#ToolEmailComposer";

export const GENOMIC_LIFE_INVITE_RECIPIENT_VIDEO_URL =
  "https://vimeo.com/1197748723/cf8f3c4c0c";

export const GENOMIC_LIFE_GIFT_GIVER_VIDEO_URL =
  "https://vimeo.com/1197748722/0bb6c3064f";
